import { Icon } from '@iwoca/orion';

import styles from './AddressInput.module.css';
import { PostcodeInput } from './PostcodeInput/PostcodeInput';
import { useAddressInput } from './useAddressInput';
import { EMPTY_ADDRESS } from '../../../../constants';
import ButtonLink from '../../../ButtonLink/ButtonLink';

type TProps = {
  allowMultipleAddresses?: boolean;
};

export const AddressInput = ({ allowMultipleAddresses = false }: TProps) => {
  const { additionalAddresses, appendAddress, removeAddress } =
    useAddressInput();

  return (
    <div className={styles.addressInputContainer}>
      <div>
        <PostcodeInput addressIndex={0} />
      </div>
      {additionalAddresses.map((additionalAddress, index) => {
        const addressIndex = index + 1;

        return (
          <div
            data-testid={`previous-address-${addressIndex}`}
            key={additionalAddress.id}
            className={styles.additionalAddressContainer}
          >
            <div className={styles.additionalAddress}>
              <PostcodeInput
                postcodeLabel={`Previous home address ${addressIndex}`}
                addressIndex={addressIndex}
                renderRemoveAddressComponent={() => (
                  <ButtonLink
                    type="button"
                    className={styles.removeAddressCTA}
                    data-testid={`delete-previous-address-${addressIndex}`}
                    onClick={() => removeAddress(addressIndex)}
                  >
                    <Icon fontSize="1.4rem" icon="trashOutline" />
                  </ButtonLink>
                )}
              />
            </div>
          </div>
        );
      })}
      {allowMultipleAddresses && (
        <ButtonLink
          type="button"
          onClick={() => {
            appendAddress(EMPTY_ADDRESS);
          }}
          className={styles.additionalAddressCTA}
        >
          <Icon fontSize="20px" icon="plus" />
          Add another address
        </ButtonLink>
      )}
    </div>
  );
};
